document.addEventListener('DOMContentLoaded', () => {
  const splash = document.getElementById('splash');
  if (!splash) return;

  // Only show splash if referrer is empty or not from the same site
  if (document.referrer && document.referrer.includes(window.location.hostname)) {
    splash.style.display = 'none';
    document.body.style.overflow = 'auto';
    return;
  }

  // Disable scrolling while splash is visible
  document.body.style.overflow = 'hidden';

  // Trigger fade-in on the logo
  const logo = splash.querySelector('.logo');
  if (logo) logo.classList.add('fade-in');

  const btn = document.getElementById('enter-btn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    splash.style.transition = 'opacity 0.5s';
    splash.style.opacity = '0';

    setTimeout(() => {
      splash.remove();
      document.body.style.overflow = 'auto'; // restore scrolling
    }, 500);
  });
});
